/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component } from '@angular/core';
import { MultilingualMetadataService } from '../../../../../../app-atmire/core/shared/multilingual-metadata.service';
import { Context } from '../../../../../../app/core/shared/context.model';
import { AtmireAbstractListableElementComponent } from '../../../../../../app-atmire/shared/object-collection/shared/object-collection-element/atmire-abstract-listable-element.component';
import { listableObjectComponent } from '../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { ViewMode } from '../../../../../../app/core/shared/view-mode.model';
import { Community } from '../../../../../../app/core/shared/community.model';

@Component({
  selector: 'ds-community-list-element',
  styleUrls: ['./community-list-element.component.scss'],
  templateUrl: './community-list-element.component.html'
})
/**
 * Component representing a list element for a community
 */
@listableObjectComponent(Community, ViewMode.ListElement, Context.Any, 'atmire')
export class CommunityListElementComponent extends AtmireAbstractListableElementComponent<Community> {
  public constructor(
    protected multilingualMetadataService: MultilingualMetadataService,
  ) {
    super(multilingualMetadataService);
  }
}
